import axios from "axios";
import { config } from "../config/env";

// Use the correct environment variable from your .env file
const baseURL = config.apiUrl;

console.log("API Base URL:", baseURL); // Debug log

const api = axios.create({
  baseURL,
  timeout: 10000,
  headers: {
    "Content-Type": "application/json",
  },
});

// Request interceptor to add auth token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("access_token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    console.error("Request error:", error);
    return Promise.reject(error);
  },
);

// Response interceptor for error handling
api.interceptors.response.use(
  (response) => response,
  (error) => {
    console.error(
      "API Error:",
      error.message,
      error.response?.status,
      error.response?.data,
    );

    if (error.response?.status === 401) {
      localStorage.removeItem("access_token");
      window.location.href = "/login";
    }

    if (!error.response) {
      console.error("Network/CORS error - check API URL and CORS.");
    }

    return Promise.reject(error);
  },
);

export { api };
